import Link from "next/link";
import { CalendarOff } from "lucide-react";
import { IconTextRow } from "~/components/ui/icon-text-row";

export function TherapistClientStatus({
  slug,
  showActions = false,
}: {
  slug: string;
  showActions?: boolean;
}) {
  return (
    <div className="space-y-3 text-sm">
      <IconTextRow icon={CalendarOff}>
        <p className="text-muted-foreground">Trenutno ne prima nove klijente</p>
      </IconTextRow>
      {showActions && (
        <>
          <p className="text-muted-foreground">
            Ako već radiš sa ovim terapeutom, i dalje možeš da zakažeš sledeću
            seansu.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-3">
            <Link
              href="/slobodni-termini"
              className="text-brand font-medium hover:underline"
            >
              Pogledaj termine drugih terapeuta
            </Link>
            <Link
              href={`/terapeuti/${slug}/book`}
              className="text-brand font-medium hover:underline"
            >
              Već radimo zajedno
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
